<p-select
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
  [options]="options()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [filter]="filter()"
  [showClear]="showClear()"
  [appendTo]="appendTo()"
  [styleClass]="styleClass()"
  [inputId]="inputId()"
  [panelStyleClass]="panelStyleClass()"
  [emptyMessage]="emptyMessage()"
  (onChange)="handleChange($event)"
  (onClear)="handleClear()"
  [ngClass]="'text-xs'"
  [size]="size()"
  [loading]="loading()">

  <ng-template *ngIf="selectedItemTemplate()" pTemplate="selectedItem" let-item>
    <ng-container *ngTemplateOutlet="selectedItemTemplate()!; context: { $implicit: item }"></ng-container>
  </ng-template>

  <ng-template *ngIf="itemTemplate()" pTemplate="item" let-item>
    <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
  </ng-template>

</p-select>
